import { render, staticRenderFns } from "./split-promotion-icon.vue?vue&type=template&id=3f133b36&functional=true"
import script from "./split-promotion-icon.vue?vue&type=script&lang=js"
export * from "./split-promotion-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports